/**
 * Twitter Widget behaviour. 
 */

(function (Drupal, $, twttr) {
  "use strict";

  Drupal = Drupal || {};

  /**
   * Init Twitter Widget
   */
  function init () {
    var js, fjs = document.getElementsByTagName("script")[0],
      t = window.twttr || {};
    if (document.getElementById("twitter-wjs")) return t;
    js = document.createElement("script");
    js.id = "twitter-wjs";
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
  }

  /**
   * JS Behaviour.
   *
   * @type {{attach: Drupal.behaviors.twitterWidget.attach}}
   */

  Drupal.behaviors.twitterWidget = {
    attach: function (context, settings) {

      jQuery('body').once('twitter', function() {

        init();

        /*** THIS FOR DEV ONLY *** 
        * As bricks are loaded asyncronus, twttr.widgets.load after each w3c is loaded. */
      
        setTimeout(function() {
          window.twttr.widgets.load();
        }, 500);

      })

    }
  }

})(Drupal, jQuery);
